<template>
  <div>
    <form
      id="uploadForm"
      class="flex justify-between items-center mb-2"
      @submit.prevent="uploadFile"
    >
      <input
        id="file-upload-drag-n-drop"
        type="file"
        @change="onFileChange($event)"
      />
      <button type="submit" class="w-1/3 bg-green text-white py-2 ml-4">
        Upload
      </button>
    </form>
    <Table ref="edTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}uploads/list`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "File Type" },
          path: "mimeType",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
      ],
      formData: undefined,
      fileData: undefined,
      // /////////////////
    }
  },
  mounted() {
    this.formData = new FormData()
  },
  methods: {
    onFileChange(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.formData.append("file", event.target.files[i])
      }
    },
    getFileData(file) {
      // will be used later
      this.axios
        .get(`${siteConfig.siteURL}uploads/${file.id}`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": localStorage.token,
          },
        })
        .then(res => {
          this.fileData = res.data.data
        })
    },
    uploadFile() {
      this.axios
        .post(`${siteConfig.siteURL}uploads/add`, this.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": localStorage.token,
          },
        })
        .then(() => {
          this.$noty.info(
            "File uploaded successfully, sort by created on to see your file."
          )
        })
    },
  },
}
</script>

<style>
#file-upload-drag-n-drop {
  height: 100px;
  border: 1px dotted black;
  background-color: #8bc34a;
}
</style>
